var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 91,
    viewBox: "0 0 92 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 90,
    height: 90,
    stroke: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6501 38.8643C28.7062 38.8643 31.4628 37.1732 33.351 34.7693C36.2943 31.0141 39.9891 27.9146 44.199 25.6693C46.9403 24.2133 49.3177 22.0444 50.4666 19.1665C51.2735 17.1503 51.6879 14.9986 51.6875 12.8269V10.4268C51.6875 9.67255 51.9871 8.94923 52.5204 8.41592C53.0537 7.88262 53.7771 7.58301 54.5313 7.58301C56.7939 7.58301 58.9638 8.48183 60.5638 10.0818C62.1637 11.6817 63.0625 13.8516 63.0625 16.1143C63.0625 20.4823 62.0767 24.619 60.3211 28.3158C59.3126 30.4316 60.7269 33.1768 63.0701 33.1768M63.0701 33.1768H74.9229C78.8131 33.1768 82.2976 35.8082 82.7109 39.6795C82.8816 41.2796 82.9688 42.9024 82.9688 44.5518C82.9844 54.9271 79.4389 64.9935 72.9246 73.0689C71.4535 74.8965 69.1823 75.833 66.839 75.833H51.6117C49.7781 75.8322 47.9566 75.5377 46.2161 74.9609L34.4089 71.0176C32.6689 70.4389 30.847 70.1445 29.0133 70.1455H22.886C23.2007 70.9228 23.542 71.6811 23.9098 72.4281C24.6567 73.9448 23.614 75.833 21.9267 75.833H18.4839C15.1131 75.833 11.9888 73.8689 11.0067 70.646C9.69346 66.3358 9.0277 61.8545 9.03126 57.3486C9.03126 51.4602 10.1498 45.8371 12.1821 40.6729C13.3424 37.7381 16.2999 36.0205 19.4583 36.0205H23.451C25.2406 36.0205 26.2758 38.1287 25.3468 39.6605C22.1083 44.9914 20.4003 51.1111 20.4101 57.3486C20.4039 61.7342 21.2459 66.0797 22.8898 70.1455M63.0701 33.1768H54.5313",
    stroke: "#F4B652",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb_up.1c2923f2ae0249aa8b999048920b9d66.svg";
export { ForwardRef as ReactComponent };